import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type SplitViewContentType = string | null

export interface SplitViewState {
  isOpen: boolean
  contextId: string | null
  contentType: SplitViewContentType
  contentId: string | null
  contentData: Record<string, unknown> | null
  panelPercent: number | null
}

const initialState: SplitViewState = {
  isOpen: false,
  contextId: null,
  contentType: null,
  contentId: null,
  contentData: null,
  panelPercent: null,
}

export interface OpenSplitViewPayload {
  contextId: string | null
  contentType: SplitViewContentType
  contentId: string
  contentData?: Record<string, unknown>
  panelPercent?: number
}

export interface UpdateSplitViewContentPayload {
  contentData: Record<string, unknown>
}

export const splitViewSlice = createSlice({
  name: 'splitView',
  initialState,
  reducers: {
    openSplitView: (state, action: PayloadAction<OpenSplitViewPayload>) => {
      state.isOpen = true
      state.contextId = action.payload.contextId
      state.contentType = action.payload.contentType
      state.contentId = action.payload.contentId
      state.contentData = action.payload.contentData ?? null
      state.panelPercent = action.payload.panelPercent ?? null
    },
    closeSplitView: (state) => {
      state.isOpen = false
      state.contentType = null
      state.contentId = null
      state.contentData = null
      state.panelPercent = null
    },
    updateSplitViewContent: (state, action: PayloadAction<UpdateSplitViewContentPayload>) => {
      if (state.isOpen) {
        state.contentData = action.payload.contentData
      }
    },
  },
})

export const { openSplitView, closeSplitView, updateSplitViewContent } = splitViewSlice.actions

export const splitViewReducer = splitViewSlice.reducer
